// import { useUsersStore } from "@/stores/user";
import axios from "axios";
import request from "@/plugins/axiosInstance";
axios.defaults.timeout = 8000;
import { useUsersStore } from "@/stores/user";
// axios.interceptors.request.use(
//   (config) => {
//     // 此处对请求进行配置
//     if (useUsersStore().logisticsToken) {
//       config.headers["Authorization"] =
//         "Bearer " + useUsersStore().logisticsToken;
//     }
//     config.headers["Accept-Language"] = "en_US";
//     config.headers["api-token"] =
//       "IoqOAOIDrywpg7pr5KbHzOw7d0xJsWWYZe4JBrvxO8-ZpvB8VbvUA8O5ejd1XrZ3qfA";
//     config.headers["user-email"] = "zmk19970720@gmail.com";
//     return config;
//   },
//   (error) => {
//     return Promise.reject(error);
//   }
// );
// export function getToken() {
//   return axios({
//     url: "https://www.universal-tutorial.com/api/getaccesstoken",
//     method: "get",
//   });
// }
// export function getCountries() {
//   return axios({
//     url: "https://www.universal-tutorial.com/api/countries",
//     method: "get",
//   });
// }

// export function getStates(query) {
//   return axios({
//     url: "https://www.universal-tutorial.com/api/states/" + query,
//     method: "get",
//   });
// }
// export function getCities(query) {
//   return axios({
//     url: "https://www.universal-tutorial.com/api/cities/" + query,
//     method: "get",
//   });
// }
// export function shopifyLogin() {
//   return axios({
//     url: "/2022-01/graphql.json",
//     method: "post",
//     headers: {
//       "X-Shopify-Storefront-Access-Token": "a3180c2527e32f85d1907b4920366eef",
//       "Content-Type": "application/json",
//     },
//   });
// }

export function searchCodes(query) {
  return axios({
    url: "https://api.zipcodestack.com/v1/search",
    method: "get",
    params: { ...query, apikey: useUsersStore().apiKey },
  });
}

// export function getCountries() {
//   return axios({
//     url: "https://api.countrystatecity.in/v1/countries",
//     method: "get",
//     headers: {
//       "X-CSCAPI-KEY":
//         "OG5yckpzRUlIU0laQ1FOMnNxcEcyYzNBMXVDQ24wVGdqa014dTlSMw==",
//     },
//   });
// }

// export function getStates(params) {
//   return axios({
//     url: `https://api.countrystatecity.in/v1/countries/${params.country}/states`,
//     method: "get",
//     headers: {
//       "X-CSCAPI-KEY":
//         "OG5yckpzRUlIU0laQ1FOMnNxcEcyYzNBMXVDQ24wVGdqa014dTlSMw==",
//     },
//   });
// }
// export function getCities(params) {
//   return axios({
//     url: `https://api.countrystatecity.in/v1/countries/${params.country}/states/${params.state}/cities`,
//     method: "get",
//     headers: {
//       "X-CSCAPI-KEY":
//         "OG5yckpzRUlIU0laQ1FOMnNxcEcyYzNBMXVDQ24wVGdqa014dTlSMw==",
//     },
//   });
// }

export function getCountries() {
  return request({
    url: "countryStateCity/getAllCountries",
    method: "get",
  });
}
export function getStates(query) {
  return request({
    url: "countryStateCity/getAllStates",
    method: "get",
    params: { countryCode: query.country },
  });
}
export function getCities(query) {
  return request({
    url: "countryStateCity/getAllCities",
    method: "get",
    params: { countryCode: query.country, stateCode: query.state },
  });
}
// 物流费用查询
export function getLogisticsCostEnquiry(params) {
  return request({
    url: "/afterSales/getLogisticsCostEnquiry",
    method: "post",
    data: params,
  });
}

// 创建退货物流单
export function createLogisticsOrders(params) {
  return request({
    url: "/afterSales/createOnlineShippingLogisticsOrders",
    method: "post",
    data: params,
  });
}
// 获取shopify运费订单付款界面
export function getShopifyPay(params) {
  return request({
    url: "/afterSales/getShopifyDraftOrderInvoicePreviewHtml",
    method: "post",
    data: params,
  });
}
// 确认shopify运费订单是否付款完成
export function confirmShopifyDraftOrderFullPaid(params) {
  return request({
    url: "/afterSales/confirmShopifyDraftOrderFullPaid",
    method: "post",
    data: params,
  });
}

// 获取物流单
export function getLogisticsOrder(params) {
  return request({
    url: "/afterSales/getLogisticsOrder",
    method: "post",
    data: params,
  });
}
